var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment, useState } from 'react';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCRipple } from '@material/ripple';
import classNames from 'classnames';
import { Menu, MenuDivider, MenuItem } from '../menu/Menu';
import { Button } from '../button/Button';
import './top-app-bar.css';
var AdapterTypes;
(function (AdapterTypes) {
    AdapterTypes["short"] = "short";
    AdapterTypes["shortCollapsed"] = "shortCollapsed";
    AdapterTypes["fixed"] = "fixed";
    AdapterTypes["prominent"] = "prominent";
    AdapterTypes["prominentDense"] = "prominentDense";
    AdapterTypes["dense"] = "dense";
})(AdapterTypes || (AdapterTypes = {}));
var TopAppBar = /** @class */ (function (_super) {
    __extends(TopAppBar, _super);
    function TopAppBar(props) {
        var _this = _super.call(this, props) || this;
        _this.ripples = [];
        _this.initRipple = function (icon) {
            if (!icon)
                return;
            var current = new MDCRipple(icon);
            current.unbounded = true;
            _this.ripples.push(current);
        };
        _this.initTopAppBar = function (element) {
            if (!element)
                return;
            if (_this.state.topAppBar) {
                _this.state.topAppBar.destroy();
            }
            _this.setState({
                topAppBar: new MDCTopAppBar(element)
            });
            if (_this.props.init) {
                _this.props.init(element);
            }
        };
        _this.renderActionItems = function (actionItems, style) {
            if (actionItems === void 0) { actionItems = []; }
            return actionItems && actionItems.length > 0 ? (React.createElement("section", { className: "mdc-top-app-bar__section mdc-top-app-bar__section--align-end", role: "toolbar", style: style },
                React.createElement(Fragment, null, actionItems.map(function (actionItem, index) {
                    switch (actionItem.actionType) {
                        case 'icon':
                            return _this.renderIcon(index, actionItem);
                        case 'button':
                            return _this.renderButton(index, actionItem);
                        case 'render':
                            return _this.renderContent(actionItem);
                        case 'menu':
                            return (React.createElement(TopAppBarMenu, __assign({ key: index }, actionItem)));
                        default:
                            return null;
                    }
                })))) : null;
        };
        _this.state = {
            topAppBar: undefined
        };
        return _this;
    }
    TopAppBar.prototype.componentWillUnmount = function () {
        this.ripples.forEach(function (ripple) { return ripple.destroy(); });
        if (this.state.topAppBar) {
            this.state.topAppBar.destroy();
        }
    };
    TopAppBar.prototype.render = function () {
        var _a = this.props, adapter = _a.adapter, onClick = _a.onClick, className = _a.className, actionItems = _a.actionItems, showMenu = _a.showMenu, title = _a.title, renderLogo = _a.renderLogo, style = _a.style;
        var isShort = adapter === AdapterTypes.short ||
            adapter === AdapterTypes.shortCollapsed;
        var classes = classNames('mdc-top-app-bar', {
            // The short variant includes the has-action-item class because the top app bar is not destroyed/recreated every
            // Time the props change so this class should persist for every short instance.
            'mdc-top-app-bar--short mdc-top-app-bar--short-has-action-item': isShort,
            'mdc-top-app-bar--short-collapsed': adapter === AdapterTypes.shortCollapsed,
            'mdc-top-app-bar--fixed': adapter === AdapterTypes.fixed,
            'mdc-top-app-bar--prominent': adapter === AdapterTypes.prominent ||
                adapter === AdapterTypes.prominentDense,
            'mdc-top-app-bar--dense': adapter === AdapterTypes.dense ||
                adapter === AdapterTypes.prominentDense
        }, className);
        return (React.createElement("header", { className: classes, ref: this.initTopAppBar },
            React.createElement("div", { className: "mdc-top-app-bar__row" },
                React.createElement("section", { className: "mdc-top-app-bar__section mdc-top-app-bar__section--align-start" },
                    showMenu && (React.createElement("button", { className: "material-icons mdc-top-app-bar__navigation-icon mdc-icon-button", ref: this.initRipple, onClick: onClick }, "menu")),
                    renderLogo && renderLogo(),
                    React.createElement(PageTitle, { title: title })),
                this.renderActionItems(actionItems, style))));
    };
    TopAppBar.prototype.renderIcon = function (index, icon) {
        var ariaLabel = icon["aria-label"];
        return (React.createElement("button", { className: 'material-icons mdc-top-app-bar__action-item mdc-icon-button', key: index, onClick: icon.onClick, "aria-label": ariaLabel, ref: this.initRipple, "data-testid": icon.iconText ? icon.iconText : '' }, icon.iconText));
    };
    TopAppBar.prototype.renderButton = function (index, button) {
        var adapter = button.adapter, value = button.value, onClick = button.onClick, className = button.className, style = button.style;
        return (React.createElement(Button, { adapter: adapter, key: index, onClick: onClick, value: value, style: style, className: className }));
    };
    TopAppBar.prototype.renderContent = function (input) {
        return input === null || input === void 0 ? void 0 : input.render();
    };
    return TopAppBar;
}(React.Component));
export { TopAppBar };
var TopAppBarMenu = function (props) {
    var _a = useState(false), isOpen = _a[0], setOpen = _a[1];
    return (React.createElement("div", null,
        React.createElement(Button, { className: props.className, onClick: function () { return setOpen(true); }, value: props.name, icon: props.icon }),
        React.createElement("div", { className: props.noAnchor ? '' : 'toolbar mdc-menu-surface--anchor' },
            React.createElement(Menu, { open: isOpen, absolute: props.absolute, defaultOpen: props.defaultOpen, handleOpenMenu: props.handleOpenMenu, handleSelected: props.handleSelected, handleCancel: function () {
                    var _a;
                    setOpen(false);
                    (_a = props.handleCancel) === null || _a === void 0 ? void 0 : _a.call(props);
                } }, props.items.map(function (item, index) {
                return item ? (React.createElement(MenuItem, { name: item.name, key: index })) : (React.createElement(MenuDivider, { key: index }));
            })))));
};
var PageTitle = function (props) {
    return props.title ? (React.createElement("span", { className: "mdc-top-app-bar__title" }, props.title)) : null;
};
//# sourceMappingURL=TopAppBar.js.map